import { render, staticRenderFns } from "./purchaseSillMoneyList.vue?vue&type=template&id=4a16f06c"
import script from "./purchaseSillMoneyList.vue?vue&type=script&lang=js"
export * from "./purchaseSillMoneyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports